import {AbstractGuard} from '../../../bonding_shared/components/abstract-guard';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {CompanyElementaryRight} from '../../../bonding_shared/model/dictionary-ids';
import {LoggedUserService} from '../../../bonding_shared/services';
@Injectable()
export class ClientCompanyAccessGuard extends AbstractGuard {
  constructor(loggedUserService: LoggedUserService, router: Router) {
    super(loggedUserService, router);
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.loggedUserService.portal || this.checkRight(state.url, CompanyElementaryRight.CLIENT_COMPANY_ACCESS);
  }
}
